export default "__VITE_ASSET__CGoGxiGu__"